import PropTypes from 'prop-types';

import { Hidden } from 'hb-react/shared/components/formik/components/inputs';

const CustomFundHidden = ({ name, gift }) => {
  if (!gift.is_fallback) {
    return null;
  }

  return (
    <Hidden
      name={name}
      validate={{
        required: true,
      }}
    />
  );
};

CustomFundHidden.propTypes = {
  name: PropTypes.string,
  gift: PropTypes.object.isRequired,
};

export default CustomFundHidden;
